import '../../brand/css/index.less';

window.onload = function () {
  function _initBox() {
    var w = $('.js-img-1').width();
    var h = $('.js-img-1').height();
    $('.js-txt-1').width(w);
    $('.js-txt-1').height(h);
    $('.js-txt-1 ul').height(h - 160);
  }
  function _init() {
    _initBox();
    $(window).resize(() => {
      _initBox();
    });
  }
  _init();
};
